"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _path, _path2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M17 18.09v-2a3.09 3.09 0 00.4-6.142l-.674-.108-.145-.667C16.039 6.683 14.12 5 12 5 9.88 5 7.96 6.684 7.42 9.173l-.146.667-.675.108A3.092 3.092 0 007 16.09v2a5.09 5.09 0 01-1.373-9.967C6.507 5.215 8.964 3 12 3s5.493 2.215 6.373 5.123A5.093 5.093 0 0117 18.09z"
  })), _path2 || (_path2 = /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 16.167l1.829-1.829 1.414 1.414L12 19.995l-4.243-4.243 1.415-1.414L11 16.167V7.995h2v8.172z"
  }))];
};

exports.default = _default;